/** Hash query param for Content entity Body deep linking (legacy EntityDetailDialog + unified screen). */
export const CONTENT_BODY_HASH_PARAM = 'contentBody';
export const CONTENT_BODY_LOADED = 'loaded';
export const CONTENT_BODY_FULLSCREEN = 'fullScreen';

export function getHashQueryParams(): URLSearchParams {
    const hash = typeof window !== 'undefined' ? (window.location.hash ?? '') : '';
    const idx = hash.indexOf('?');
    const qs = idx >= 0 ? hash.slice(idx + 1) : '';
    return new URLSearchParams(qs);
}

export function getHashQueryParam(key: string): string | null {
    return getHashQueryParams().get(key);
}

/** Set or remove a single query param on the current hash route; preserves other params (e.g. search=). */
export function setHashQueryParam(key: string, value: string | null): void {
    if (typeof window === 'undefined') return;
    const hash = window.location.hash ?? '';
    const idx = hash.indexOf('?');
    const base = idx >= 0 ? hash.slice(0, idx) : hash;
    const params = getHashQueryParams();
    if (value == null) params.delete(key);
    else params.set(key, value);
    const next = params.toString();
    window.location.hash = next ? `${base}?${next}` : base;
}

export function clearContentBodyHashParam(): void {
    setHashQueryParam(CONTENT_BODY_HASH_PARAM, null);
}

export function isContentBodyFullScreenHash(): boolean {
    return getHashQueryParam(CONTENT_BODY_HASH_PARAM) === CONTENT_BODY_FULLSCREEN;
}

export function isContentBodyLoadedOrFullScreenHash(): boolean {
    const v = getHashQueryParam(CONTENT_BODY_HASH_PARAM);
    return v === CONTENT_BODY_LOADED || v === CONTENT_BODY_FULLSCREEN;
}
